import {
  useAddProgramToGroup,
  useCreateProgramGroup,
  useDeleteProgramGroup,
  useGetProgramGroupById,
  useGetProgramGroups,
  useRestoreProgramGroup,
  useUpdateProgramGroup,
  useUpdateProgramGroupProgramMetrics,
} from './useProgramGroups'

export type {
  CreateProgramGroupRequest,
  ProgramGroup,
  ProgramGroupDetail,
  ProgramGroupInstance,
  ProgramGroupInstanceCorrectResponseMetric,
  ProgramGroupInstanceCorrectResponseSummaryMetric,
  ProgramGroupInstanceMetrics,
  ProgramGroupInstanceProgram,
  ProgramGroupsListParams,
  ProgramGroupStatus,
  UpdateProgramGroupRequest,
  UpdateProgramGroupProgramMetricsRequest,
} from './useProgramGroups'

export const programGroups = {
  getList: useGetProgramGroups,
  getById: useGetProgramGroupById,
  create: useCreateProgramGroup,
  addProgramToGroup: useAddProgramToGroup,
  update: useUpdateProgramGroup,
  updateProgramMetricsConfig: useUpdateProgramGroupProgramMetrics,
  delete: useDeleteProgramGroup,
  restore: useRestoreProgramGroup,
}
